<template>
    <v-icon :size="size" >{{icon}}</v-icon>
</template>

<script>
    import {getStatusColor, getStatusIcon} from '@/utils/ScheduleEvent'
    export default{
        props: {
          eventStatus: {
            type: Object
          },
          size: {
            type: Number,
            default: 15
          }
        },
        computed: {
            color(){
                return getStatusColor(this.eventStatus.id)
            },
            icon(){
                return getStatusIcon(this.eventStatus.id)
            }
        }
    }
</script>
